export const SIMPLE = "SIMPLE";
export const SKLAD_CHILD = "SKLAD_CHILD";
export const SMS = "SMS";
export const SERVICES = "SERVICES";
export const SPRAVOCHNIK = "SPRAVOCHNIK";
export const HISOBOT = "HISOBOT";
